import React, { Component } from "react";

import DeleteView from "../../../view/delete";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { deleteCommentQuestion } from "../../../../helper/comment_helper";

class DeleteAnswer extends Component {
  state = { deleting: false };

  componentWillUnmount() {
    if (this.deleteCall) {
      this.deleteCall.cancel();
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="" onClick={this.removeAnswerClick}>
          <FontAwesomeIcon className="" icon={faTrash} />
        </div>
        {this.renderDeleteAnswer()}
      </React.Fragment>
    );
  }

  removeAnswerClick = e => {
    //if (this.state.deleting === false) this.props.handleCloseView();

    const deleting = !this.state.deleting;
    this.setState({ deleting });
  };

  removeAnswer = e => {
    const self = this;
    // this.setState({
    //   loaded: false
    // });

    this.deleteCall = deleteCommentQuestion(this.props.answer.id);
    this.deleteCall.promise
      .then(answer => {
        self.props.removeAnswer(this.props.answer);
      })
      .catch(errors_ => {
        const errors = errors_.errors;
        self.props.errorsAPI(errors);
      });
  };

  renderDeleteAnswer() {
    if (this.state.deleting) {
      console.log("renderDeleteAnswer");
      return (
        <DeleteView
          message={"Delete Answer"}
          delete={this.removeAnswer}
          cancel={this.removeAnswerClick}
        />
      );
    }
    return <div />;
  }
}

export default DeleteAnswer;



// WEBPACK FOOTER //
// ./src/components/list/interface/answer/delete_answer.jsx